import { dismiss, showReasons } from '../../utils/ufo';
export const observabilitySideEffects = ({
  action
}) => {
  try {
    switch (action.type) {
      case 'SHOW_REASONS':
        showReasons.start();
        break;
      case 'DISMISS_START':
        dismiss.start();
        break;
      case 'DISMISS_SUCCESS':
        dismiss.success();
        break;
      case 'DISMISS_FAILURE':
        dismiss.failure();
        break;
      default:
        break;
    }
  } catch (error) {
    // TODO: error handling
  }
};